export default {
  isPrerendererBrowser() {
    return (
      window['__PRERENDER_INJECTED'] &&
      window['__PRERENDER_INJECTED'].isPrerenderBrowser
    )
  }
}
